import { render, staticRenderFns } from "./QuoteView.vue?vue&type=template&id=bcd45de0&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"
import style0 from "./QuoteView.vue?vue&type=style&index=0&id=bcd45de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd45de0",
  null
  
)

export default component.exports